import React from 'react';
import PokedexFiltersVariants from './PokedexFiltersVariants';
import PokedexFiltersTypes from './PokedexFiltersTypes';
import PokedexFiltersGenerations from './PokedexFiltersGenerations';
import PokedexFiltersStats from './PokedexFiltersStats';
import PokedexChangePokemonButtons from './PokedexChangePokemonButtons';
import PokedexFiltersSpecial from './PokedexFiltersSpecial';

function PokedexFilters() {
  return (
    <div className="overflow-auto">
      <div className="flex justify-center">
        <p className="text-xl font-bold">Options</p>
      </div>
      <div className="my-4">
        <PokedexFiltersVariants />
      </div>
      <div className="my-4">
        <PokedexFiltersGenerations />
      </div>
      <div className="my-4">
        <PokedexFiltersTypes />
      </div>
      <div className="my-4">
        <PokedexFiltersStats />
      </div>
      <div className="my-4">
        <PokedexFiltersSpecial />
      </div>
      <div className="block my-4">
        <PokedexChangePokemonButtons />
      </div>
    </div>
  );
}

export default PokedexFilters;
